import { SHOW_NEW_POST_MESSAGE } from '../actions/show-new-post-message';
import { HIDE_NEW_POST_MESSAGE } from '../actions/hide-new-post-message';

const initialState = null;
export default (state = initialState, action = {}) => {
  switch (action.type) {
    case SHOW_NEW_POST_MESSAGE:
      return action.payload;
    case HIDE_NEW_POST_MESSAGE:
      return initialState;
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./app/reducers/new-post-message.js